import React, { useState, useEffect } from 'react';
import './Hero.css';
import jornadaImage from '../../assets/tresHam.webp';
import suculentaImage from '../../assets/suculenta.webp';
import selecionadaImage from '../../assets/selecionada.webp';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      image: jornadaImage,
      title: 'A Jornada da Primeats',
      subtitle: 'Começa aqui!'
    },
    {
      id: 2,
      image: suculentaImage,
      title: 'Mais Suculência, Mais Sabor',
      subtitle: 'Nova marca, mesma paixão'
    },
    {
      id: 3,
      image: selecionadaImage,
      title: 'Hambúrguer Suculento',
      subtitle: 'Começa com carne selecionada'
    }
  ];

  // Auto-play do carrossel
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) => 
        prevSlide === slides.length - 1 ? 0 : prevSlide + 1
      );
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide(currentSlide === slides.length - 1 ? 0 : currentSlide + 1);
  };

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? slides.length - 1 : currentSlide - 1);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const scrollToCatalog = () => {
    const element = document.getElementById('catalogo');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="hero">
      <div className="hero-container">
        <div className="hero-slider">
          {slides.map((slide, index) => (
            <div
              key={slide.id}
              className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
            >
              <img 
                src={slide.image} 
                alt={slide.title}
                className="hero-slide-image"
              />
              <div className="hero-overlay">
                <div className="hero-content">
                  <h1 className="hero-title">{slide.title}</h1>
                  <p className="hero-subtitle">{slide.subtitle}</p>
                  <button className="hero-button" onClick={scrollToCatalog}>
                    Conheça Nossos Produtos
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Controles do carrossel */}
        <button className="hero-nav hero-nav-prev" onClick={prevSlide}>
          <span>‹</span>
        </button>
        <button className="hero-nav hero-nav-next" onClick={nextSlide}>
          <span>›</span>
        </button>

        {/* Indicadores */}
        <div className="hero-indicators">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`hero-indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
